<script setup lang="ts">
import { computed } from "vue";

import SelectStickyType from "@/components/SelectStickyType/SelectStickyType.vue";
import type { StickyType } from "@/model/stickyType";
import type { useActivityStore } from "@/store/activity";
import { useBoardStore } from "@/store/board";
import type { useSearchMenuStore } from "@/store/search/searchMenu";

import StickyTypeItemTooltip from "../tooltips/StickyTypeItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";

const props = defineProps<{
  store: ReturnType<typeof useSearchMenuStore> | ReturnType<typeof useActivityStore>;
}>();

const stickyTypes = useBoardStore().possibleStickyTypes;

const selection = computed({
  get: () => props.store?.selectedStickyTypes,
  set: (values: StickyType[]) => props.store.selectStickyTypes(values),
});
</script>

<template>
  <SearchDropdown
    name="sticky-type"
    icon="general/sticky"
    label-key="general.stickyTypes"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <StickyTypeItemTooltip :types="selection" />
    </template>
    <SelectStickyType v-model="selection" :sticky-types />
  </SearchDropdown>
</template>
